// Mock data for Indya Bungy website

export const locations = [
  {
    id: 1,
    name: "GOA",
    image: "https://images.unsplash.com/photo-1512343879784-a960bf40e7f2?w=800&q=80",
    available: true,
    description: "Experience India's highest bungee jump in the party capital"
  },
  {
    id: 2,
    name: "Delhi NCR",
    image: "https://images.unsplash.com/photo-1587474260584-136574528ed5?w=800&q=80",
    available: true,
    description: "Jump from 61 meters in the heart of India"
  },
  {
    id: 3,
    name: "Coorg",
    image: "https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?w=800&q=80",
    available: true,
    description: "Bungee jumping in the Scotland of India"
  },
  {
    id: 4,
    name: "Mumbai",
    image: "https://images.unsplash.com/photo-1529253355930-ddbe423a2ac7?w=800&q=80",
    comingSoon: true,
    description: "Coming Soon"
  },
  {
    id: 5,
    name: "Bangalore",
    image: "https://images.unsplash.com/photo-1596176530529-78163a4f7af2?w=800&q=80",
    comingSoon: true,
    description: "Coming Soon"
  },
  {
    id: 6,
    name: "Hyderabad",
    image: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800&q=80",
    comingSoon: true,
    description: "Coming Soon"
  },
  {
    id: 7,
    name: "Kerala",
    image: "https://images.unsplash.com/photo-1602216056096-3b40cc0c9944?w=800&q=80",
    comingSoon: true,
    description: "Coming Soon"
  },
  {
    id: 8,
    name: "Jaipur",
    image: "https://images.unsplash.com/photo-1477587458883-47145ed94245?w=800&q=80",
    comingSoon: true,
    description: "Coming Soon"
  }
];

export const excellenceItems = [
  {
    id: 1,
    title: "Indya Bungy X Wonderla",
    image: "https://images.unsplash.com/photo-1520962922320-2038909c6ecb?w=400&q=80"
  },
  {
    id: 2,
    title: "Ministry of Tourism Goa",
    image: "https://images.unsplash.com/photo-1589519160732-57fc498494f8?w=400&q=80"
  },
  {
    id: 3,
    title: "Allied Member of ATOAI",
    image: "https://images.unsplash.com/photo-1557804506-669a67965ba0?w=400&q=80"
  },
  {
    id: 4,
    title: "Consultant to Iran Bungy",
    image: "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=400&q=80"
  },
  {
    id: 5,
    title: "Jump Master Certification",
    image: "https://images.unsplash.com/photo-1565688534245-05d6b5be184a?w=400&q=80"
  },
  {
    id: 6,
    title: "Consultant to Colombia Bungy",
    image: "https://images.unsplash.com/photo-1559027615-cd4628902d4a?w=400&q=80"
  },
  {
    id: 7,
    title: "Certification from Thailand",
    image: "https://images.unsplash.com/photo-1569025690938-a00729c9e1f9?w=400&q=80"
  }
];

export const medicalConditions = [
  {
    id: 1,
    condition: "Any Heart Conditions",
    icon: "Heart"
  },
  {
    id: 2,
    condition: "Pregnancy",
    icon: "Baby"
  },
  {
    id: 3,
    condition: "High Blood Pressure",
    icon: "Activity"
  },
  {
    id: 4,
    condition: "Back Ache",
    icon: "AlertCircle"
  },
  {
    id: 5,
    condition: "Any Dislocations",
    icon: "XCircle"
  },
  {
    id: 6,
    condition: "Recent Fracture",
    icon: "AlertTriangle"
  },
  {
    id: 7,
    condition: "Osteoporosis",
    icon: "Shield"
  },
  {
    id: 8,
    condition: "Spondylitis",
    icon: "Slash"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "SW. MASTANA",
    text: "All staff members are wonderful people. thx a lot everyone. Today my birthday nd I celebrate my birthday with JUMP",
    avatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=Mastana"
  },
  {
    id: 2,
    name: "SANTOSH M",
    text: "Awesome experience, it's really worth doing it. The staff are so friendly and overall AWEEEESSSOOOMMMMEEEEEE!!!!!!!",
    avatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=Santosh"
  },
  {
    id: 3,
    name: "Priyank Parmar",
    text: "It was amazing experience here bungee jumping at goa ..satish bhai made the bungee jumping so fearless one must try here ..",
    avatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=Priyank"
  },
  {
    id: 4,
    name: "Rahul Sharma",
    text: "Best adventure experience of my life! The safety measures are top-notch and the team is very professional.",
    avatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=Rahul"
  },
  {
    id: 5,
    name: "Priya Singh",
    text: "Conquered my fear! The jump was exhilarating and the staff made me feel safe throughout. Highly recommended!",
    avatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=Priya"
  }
];

export const galleryImages = [
  {
    id: 1,
    url: "https://images.unsplash.com/photo-1518136247453-74e7b5265980?w=800&q=80",
    title: "DARE"
  },
  {
    id: 2,
    url: "https://images.unsplash.com/photo-1476900164809-ff19b8ae5968?w=800&q=80",
    title: "PLUNGE"
  },
  {
    id: 3,
    url: "https://images.unsplash.com/photo-1483884105135-c06ea0f67b02?w=800&q=80",
    title: "SOAR"
  },
  {
    id: 4,
    url: "https://images.unsplash.com/photo-1503220317375-aaad61436b1b?w=800&q=80",
    title: "THRILL"
  },
  {
    id: 5,
    url: "https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?w=800&q=80",
    title: "JUMP"
  },
  {
    id: 6,
    url: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=800&q=80",
    title: "LEAP"
  },
  {
    id: 7,
    url: "https://images.unsplash.com/photo-1519713958759-6254243c4a53?w=800&q=80",
    title: "FLY"
  },
  {
    id: 8,
    url: "https://images.unsplash.com/photo-1524250502761-1ac6f2e30d43?w=800&q=80",
    title: "DIVE"
  }
];

export const jumpDiaries = [
  {
    id: 1,
    title: "DARE",
    videoUrl: "https://www.youtube.com/embed/nHoW8vcksFk",
    thumbnail: "https://images.unsplash.com/photo-1518136247453-74e7b5265980?w=600&q=80"
  },
  {
    id: 2,
    title: "PLUNGE",
    videoUrl: "https://www.youtube.com/embed/nHoW8vcksFk",
    thumbnail: "https://images.unsplash.com/photo-1476900164809-ff19b8ae5968?w=600&q=80"
  },
  {
    id: 3,
    title: "SOAR",
    videoUrl: "https://www.youtube.com/embed/nHoW8vcksFk",
    thumbnail: "https://images.unsplash.com/photo-1483884105135-c06ea0f67b02?w=600&q=80"
  },
  {
    id: 4,
    title: "THRILL",
    videoUrl: "https://www.youtube.com/embed/nHoW8vcksFk",
    thumbnail: "https://images.unsplash.com/photo-1503220317375-aaad61436b1b?w=600&q=80"
  }
];